import axios from 'axios';

type GetEnhancedAnsweringPricesDTO = {
  priceId: string;
  range: string;
  amount: number;
}[];

const getEnhancedAnsweringPrices = async () => {
  const { data } = await axios.get<GetEnhancedAnsweringPricesDTO>(
    '/answering_subscription/enhanced_prices',
  );

  return data;
};

export default getEnhancedAnsweringPrices;
